import { Component, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SortPipe } from '../_helpers/sort.pipe';
import { LazyLoadImgDirective } from '../_helpers/lazy-load-img.directive';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import { CommonService } from '../_service/common.service';
import { appConfig, dev, int, intUrl, localUrl, opeUrl, share, baseUrl, opewafUrl,opeNewwafUrl } from '../app.config';
import { Subscription, Subject, interval, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { PagerService } from '../_service/pager-service';
import * as XLSX from 'xlsx';
import { NotificationService } from '../_service/notification.service';
import { SupplierService } from '../_service/supplier.service';
import { SitesService } from '../_service/sites.service';

const TWO = 2;
const THREE = 3;
const FOUR = 4;
const FIVE = 5;
const SIX = 6;
const TEN = 10;
const TWENTY = 20;
const ONE_HUNDRED = 100;
const KEY_ENTER = 13;
const SHORT_DELAY_MS = 1500;

@Component({
    selector: 'app-company',
    templateUrl: './company.component.html',
    styleUrls: ['./company.component.css'],
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterLink, RouterModule,
        MatIconModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule,
        MatSelectModule, MatOptionModule, MatTooltipModule, MatProgressSpinnerModule,
        MatProgressBarModule, NgxPaginationModule, NgSelectModule, NgbModule,
        NgxMatSelectSearchModule, SortPipe, LazyLoadImgDirective,
        HelpsectionComponent, SuppliertabComponent
    ]
})

export class CompanyComponent implements OnInit, DoCheck {
  private static readonly DEBOUNCE_MS = 400;
  private static readonly UI_REFRESH_DELAY_MS = 500;
  private static readonly BATCH_REFRESH_DELAY_MS = 2000;
  private static readonly PAGE_HEIGHT_NAME_ROW_FACTOR = 60;
  private static readonly PAGE_HEIGHT_ROLE_ROW_FACTOR = 30;
  private static readonly PAGE_HEIGHT_BASE_OFFSET = 300;
  private static readonly PAGE_HEIGHT_FALLBACK = 550;
  readonly ngUnsubscribe = new Subject();
  userQuestionUpdate = new UntypedFormControl();
  userQuestionUpdate2 = new UntypedFormControl();

  Config: any;
  public data: any;
  loading = false;
  loadData = false;
  public CIdentifierTypes = [];
  static readonly IDENTIFIER_TYPE = 'Company ID';
  CIdentifierTypeModel: string = CompanyComponent.IDENTIFIER_TYPE;
  CidenTypeselectedValue: any;
  public CIdentifierValue: any = []; //string
  public CIdentifierValueCheck: any = []; //string
  public IdentifierValueModel = '';

  public KeyIdentifierValue: any = []; //string
  public KeyAllianceIvalueCmpName: any = []; //string
  public selectedIdentiValue: any;
  public CmpIdentifierCIDBased = [];
  public CmpIdgroupAssign = [];
  public CmpRouting = [];
  public colorStatus = { "archived": "#CB4B32", "active": "#5CBA63", "draft": "Yellow", "validated": "#5CBA63", 'pending_validation': '#FFBD69', 'pending': '#B7783C', 'greenfield': '#FFBD69', 'brownfield': '#FFBD69', "destroyed": "#CB4B32", "built": "#5CBA63", "waiting for approval": "#B7783C", "created": "#FFBD69", "identified": "#D8C4A0" }
  public colors = { "": "#D8C4A0", "approved": "#5CBA63", "identified": "#D8C4A0", "pending": "#B7783C", "registered": "#66D8D0", "archived": "#CB4B32", "waiting for approval": "#B7783C", "prospect": "#4B9BF5", "inactive": "#FFBD69" }
  public workflowStatusColors = { "NotStarted": "#D8C4A0", "WaitingForSupplier": "#B7783C", "WaitingForRenault": "#B7783C", "Completed": "#5CBA63" }
  public colorsGroup = { "": "#D8C4A0", "active": "#5CBA63", "inactive": "#FFBD69", "pending": "#B7783C", "archived": "#CB4B32", "blocked": "#D8C4A0", "waiting for approval": "#B7783C", "identified": "#D8C4A0" }
  public OrbisStatusAll = ['Active', 'Active+', 'Inactive', "Administratively suspended", 'In liquidation', 'Dissolved', 'Bankruptcy', 'Status unknown'];
  public CmpNameValue: any = []; //strinf
  public CmpNameeModel = '';
  public selectedcmpName: any;

  public companyNameModel = '';
  public companyTaxIdentyModel = '';
  public companyNameModelError = false;
  saveDatas = "Save";
  public companyStatusRowid = '';
  public companyRowId = '';
  public mainTaxRowid = '';
  public pageinCid: any = []; //string
  public IdenKeywithId = [];
  public pageInAlianId: any = [];//string
  public cmpIDwithDetails = [];
  public minlength = FIVE;
  public PageTotalLength = 0;
  pager = {};
  pageAllinfos: { totalItems: number; currentPage: number; pageSize: number } = { totalItems: 0, currentPage: 1, pageSize: 0 };
  public srchSelector = "";
  public maxRecorePage = TWENTY;
  statusDropdown = false;
  CompanyStatusAll = [];
  selectedStatus = '';
  public envHide: any = ""; //boolean

  public customLoadingTemplate: any;
  public customLoadingTemplate2: any;
  public roleVariableHide = false;
  public filterCpyModel = '';
  public payingCpyData = [];
  public payingCpyLoading = false;
  public pager2 = {};
  public ShortNameData = [];
  public BvdIDData = [];
  public bvdRowId = [];
  public prodHide = false;
  public superUserShow = false;
  public maxCpyNameLength = '60';
  public cityAndCountryData = [];
  public cpyRowIdsForAssn = [];
  public aliasTextDisp = '';
  public pageBatchNo = 0;
  public cancelCpyAlcorProcessing = false;
  public progressForCpyAlcor = '';
  public maxPageForCpyBatch = 0;
  public idenTypeChange = false;
  public showCpyBatchToSuper = false;
  public cpyBatchBtn = 'Cancel';
  public showBuyerProfile = false;
  public showForConsult = false;
  showForSupplier: boolean;
  public companyNameModelRegExError = false;
  public cancelCpyHQProcessing = false;
  public pageHQBatchNo = 0;
  public aliasTextDispHQ = '<img src="assets/images/loading.gif" alt="loading...">';
  public maxCompanyPage = 0;
  public HQBatchPageHolder: any;
  public checkHqACP = "'P11','P05','P18','P06'";
  batchObj = {};
  timerForBatchStart: number;
  subscription: Subscription;
  tableDataForCpyHqBatch = [];
  public showDownloadButton = false;
  public disableCompCreateBtn = false;
  public alcorCodesOnCpyIds = [];
  public pageHeight: number;
  groupMdmSwitch: boolean;
  activityTypes = [];
  filteredTypes: Observable<string[]>;
  activityCtrl = new UntypedFormControl();

  activityTypeCtrl = new UntypedFormControl();
  filteredActivityTypes: any[];
  activityDropdown = false;
  selectedActivityType = '';
  autoload = false;
  autoload1 = false;
  enterKey: boolean;
  type: string;
  key = 'name';
  reverse = false;
  roleIsManager: boolean;
  payPager = {};
  payingSortKey = '';
  payingSortReverse = false;
  allPayingCpyData = []; // Store all paying company data for client-side sorting
  orbisDropdown = false;
  selectedOrbisStatus = '';
  allOrbisData = [];
  OrbisIdentifiers = [];
  workflowDropdown = false;
  selectedWorkflowStatus = '';
  WorkflowStatusAll = ['NotStarted', 'WaitingForSupplier', 'WaitingForRenault', 'Completed'];
  numberthree = THREE
  constructor(public commonService: CommonService,readonly supplierService: SupplierService, readonly sitesService: SitesService, readonly router: Router, readonly pagerService: PagerService, readonly notificationService: NotificationService) {

    this.Config = appConfig;
    const debonuceTime = CompanyComponent.DEBOUNCE_MS
    this.userQuestionUpdate.valueChanges.pipe(debounceTime(debonuceTime), distinctUntilChanged()).subscribe(value => {
      this.IdentifierValueModel = value;
      if (value !== this.selectedIdentiValue) {
        this.selectedIdentiValue = null;
      }
      this.IdValueKeyup(value.trim());
    });

    this.userQuestionUpdate2.valueChanges.pipe(debounceTime(debonuceTime), distinctUntilChanged()).subscribe(value2 => {
      this.CmpNameeModel = value2
      this.CmpValuekeyup(value2.trim());
    });
  }

  onActivityTypeSelect(event: any): void {
    const selectedValue = event.value;
    this.selectedActivityType = selectedValue;
    this.activityCtrl.setValue('');
  }
  private filterActivityTypes(value: string) {
    const filterValue = value.toLowerCase();
    this.filteredActivityTypes = this.activityTypes.filter(activityType =>
      activityType.toLowerCase().includes(filterValue));
  }

  ngOnInit() {
    this.activityDropdown = false;
    this.activityTypeCtrl.valueChanges.subscribe(_value => {
    });
    this.activityCtrl.valueChanges.subscribe(value => {
      this.filterActivityTypes(value);
    });
    this.data = "";
    this.AllCompanyIdentifierTypes();
    this.loadData = false;
  }
  ngDoCheck() {
    this.getRoles();
  }

  getRoles() {
    const RoleByService = this.commonService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  checkAllProfilesAndEnv(RoleByService) {
    const c = RoleByService;
    this.showBuyerProfile = c['buyer'] !== 'yes';
    this.roleIsManager = this.hasRole(c['role'], 'manager');
    this.envHide = !this.isEnv(c['env'], ['qua', 're7', 'ope']);
    this.roleVariableHide = this.isRole(c['role'], 'admin');
    this.superUserShow = c['superAdmin'] === 'yes';
    this.prodHide = c['env'] === 'ope';
    this.showCpyBatchToSuper = c['superAdminAllProfiles'] === 'yes';
    this.showForConsult = !this.isRole(c['role'], 'consult');
    this.showForSupplier = c['role'] !== 'supplier';
  }

  private hasRole(role: string, target: string): boolean {
    return Array.isArray(role)
      ? role.includes(target)
      : typeof role === 'string' && role.includes(target);
  }

  private isRole(role: string, target: string): boolean {
    return role.includes(target) || (typeof role == 'string' && role.includes(target));
  }

  private isEnv(env: string, targets: string[]): boolean {
    return targets.includes(env);
  }


  CmpValuekeyup(value, page = 1, byClick = "No") {
    if (value.length >= this.numberthree) {
      this.autoload = true
      try {
        this.supplierService.getCompanies(
          `${this.Config.ApiSupplierUrl}companies?legalName=*${encodeURIComponent(value)}*&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`
        ).subscribe((data: any) => {
          this.CmpNameValue = "";
          this.CmpNameValue = [];
          this.pageinCid = "";
          this.pageinCid = [];
          this.KeyIdentifierValue = "";
          this.KeyIdentifierValue = [];
          this.KeyAllianceIvalueCmpName = "";
          this.KeyAllianceIvalueCmpName = [];
          this.alcorCodesOnCpyIds = [];

          for (const element of data['companies']) {
            this.CmpNameValue.push(element.legalName);
            this.KeyIdentifierValue[element.allianceIdentifier] = element;
            this.KeyAllianceIvalueCmpName[`${element.allianceIdentifier}___${element.legalName}`] = element;
            this.pageinCid.push(element.rowId);
          }
          this.pageAllinfos.totalItems = data['count'];
          this.pageAllinfos.currentPage = data['page'];
          this.pageAllinfos.pageSize = data['pageCount'];
          this.pager = this.pagerService.getPager(this.pageAllinfos['totalItems'], this.pageAllinfos['currentPage'], this.maxRecorePage);
          this.PageTotalLength = this.pageAllinfos.totalItems
          this.autoload = false
          if (byClick == "cked") {
            setTimeout(function () {
              this.getSearch();
            }.bind(this), CompanyComponent.UI_REFRESH_DELAY_MS);
          }
        });
      } catch (error) {
      }
    }
    else {
      this.CmpNameValue = [];
      this.pageinCid = "";
      this.pageinCid = [];
      this.KeyIdentifierValue = "";
      this.KeyIdentifierValue = [];
      this.KeyAllianceIvalueCmpName = "";
      this.KeyAllianceIvalueCmpName = [];
    }
  }

  resetOtherFields(resetparam: any, event) {
    this.minlength = FIVE
    if (resetparam == 'IdentifierValueModel') {
      this.filterCpyModel = '';
      this.IdentifierValueModel = '';
      this.userQuestionUpdate.setValue('');
      this.srchSelector = 'CmpName';
      this.minlength = this.numberthree
      this.idenTypeChange = false;
      this.selectedOrbisStatus = '';
      this.selectedStatus = '';
      this.selectedWorkflowStatus = '';
      this.activityCtrl.setValue('');
    } else if (resetparam == 'CmpNameeModel') {
      this.filterCpyModel = '';
      this.CmpNameeModel = '';
      this.userQuestionUpdate2.setValue('');
      this.srchSelector = 'IdfValue';
      if (event['keyCode'] != KEY_ENTER) {
        this.idenTypeChange = false;
      }
    } else if (resetparam == 'filter') {
      this.IdentifierValueModel = '';
      this.CmpNameeModel = '';
      this.srchSelector = 'filter';
      this.idenTypeChange = false;
    } else if (resetparam == 'filter') {
      this.IdentifierValueModel = '';
      this.CmpNameeModel = '';
      this.srchSelector = 'filter';
      this.idenTypeChange = false;
    }
    this.data = "";
    this.loadData = false;
  }

  AllCompanyIdentifierTypes(page = 1, subscribeData = []) {
    this.CIdentifierTypes = [];
    this.supplierService.getCompanyIdentifierKeys(`${this.Config.ApiSupplierUrl}company-identifier-keys?_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data['company-identifier-keys'].length > 0) {
        data['company-identifier-keys'].forEach((element: any) => {
          subscribeData.push(element);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.AllCompanyIdentifierTypes(page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          let omitIden = ['duns', 'siren', 'vat', 'secondary vat', 'main tax id']
          this.CIdentifierTypes.push('Activity type');

          subscribeData.forEach(element => {
            if (omitIden.indexOf(element['name'].toLowerCase()) == -1) {
              if ((element['name'].toLowerCase() == 'mdm' || element['name'].toLowerCase() == 'gtop') && this.CIdentifierTypes.indexOf('GTOP/MDM') == -1) {
                this.CIdentifierTypes.push('GTOP/MDM');
              } else if (element['name'].toLowerCase() != 'mdm' && element['name'].toLowerCase() != 'gtop') {
                if (element['name'].toLowerCase() == 'european vat number' && this.showForConsult == true) {
                  this.CIdentifierTypes.push(element['name']);
                } else if (element['name'].toLowerCase() != 'european vat number') {
                  let name = element.name.toLowerCase();
                  if (name == 'alcor') {
                    element['name'] = 'Supplier code (COFOR)'
                    this.CIdentifierTypes.unshift(element['name']);
                    this.CIdentifierTypeModel = element['name'];
                  } else {
                    this.CIdentifierTypes.push(element['name']);
                  }
                }
              }
              this.IdenKeywithId[element['name']] = element['row_id'];
            }
          });
          this.CIdentifierTypes.push(CompanyComponent.IDENTIFIER_TYPE);
          this.CIdentifierTypes.push('Company Short Name');
          this.CIdentifierTypes.push('BvD ID');
          this.CIdentifierTypes.push('Tax ID');
          this.CIdentifierTypes.push('Orbis Status');
          this.CIdentifierTypes.push('Company Status');
          this.CIdentifierTypes.push('Workflow Status');
          this.CIdentifierTypes.push('DUNS');
          this.CIdentifierTypes.push('BPN');
        }
        for (let i = 0; i < this.CIdentifierTypes.length; i++) {
          if (this.CIdentifierTypes[i] === 'EUROPEAN VAT NUMBER') {
            this.CIdentifierTypes.splice(i, 1);
          }
        }
      }
    }, error => {
      console.info(error);
      this.CIdentifierTypes[0] = CompanyComponent.IDENTIFIER_TYPE;
      this.notificationService.showError('Company Identifiers Error');
    });
  }

  restAlldatas(_ss) {
    this.activityDropdown = false;
    this.statusDropdown = false;
    this.idenTypeChange = true;
    this.CompanyStatusAll = [];
    this.selectedActivityType = '';
    this.orbisDropdown = false;
    this.userQuestionUpdate.setValue('');
    this.userQuestionUpdate2.setValue('');
    if (this.CIdentifierTypeModel.toLowerCase() == "alliance company id") {
      this.minlength = FIVE;
    } else {
      this.minlength = TWO;
    }
    if (this.CIdentifierTypeModel == 'Company Status') {
      this.statusDropdown = true;
      this.idenTypeChange = false;
      this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status`).subscribe((data: any) => {
        const excludedStatusCodes = new Set(['registered', 'pending', 'waiting for approval', 'waiting_for_approval']);
        data['company-status'].forEach(element => {
          const normalizedCode = (element['code'] || '').toString().trim().toLowerCase();
          if (!excludedStatusCodes.has(normalizedCode)) {
            this.CompanyStatusAll.push(element);
          }
        });
      });
    }
    else {
      this.activityDropdown = false;
      this.selectedStatus = '';
      this.statusDropdown = false;
    }
    if (this.CIdentifierTypeModel == 'Orbis Status') {
      this.statusDropdown = false;
      this.idenTypeChange = false;
      this.orbisDropdown = true;
      this.selectedStatus = '';
    }
    else {
      this.orbisDropdown = false;
    }
    if (this.CIdentifierTypeModel == 'Workflow Status') {
      this.statusDropdown = false;
      this.orbisDropdown = false;
      this.idenTypeChange = false;
      this.workflowDropdown = true;
    }
    else {
      this.workflowDropdown = false;
    }
    if (this.CIdentifierTypeModel == 'Activity type') {
      let types = []
      this.idenTypeChange = false;
      this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types?name=SUPPLIER%20ACTIVITY`).subscribe((data: any) => {
        data['company-name-types'].forEach(data => {
          data.description = data.description.replace('<p>', '')
          data.description = data.description.replace('</p>', '')
          let separators = ['<br>', '<br />'];
          let regex = new RegExp(separators.join('|'), 'g');
          types = data.description.split(regex);
          this.activityTypes = types.map(data => data.substring(TWO));
          this.filteredActivityTypes = this.activityTypes;

          this.activityDropdown = true;
        })
        console.info('activityTypes', this.activityTypes)
      })
    } else {
      this.activityDropdown = false;
      this.activityTypeCtrl.setValue('')
    }
    this.CmpNameeModel = '';
    this.CIdentifierValue = "";
    this.data = "";
    this.loadData = false;
  }
  displayActivity(value) {
    return value.substring(TWO)
  }
  IdValueKeyup(event: any) {
    this.minlength = this.CIdentifierTypeModel == 'GTOP/MDM' ? FOUR : FIVE
    if (event.length >= this.minlength) {
      let c;
      if (this.idenTypeChange == true) {
        c = 'cked';
      }
      if (this.CIdentifierTypeModel.toLowerCase() == "alliance company id") {
        this.selectedCIddentifier2(this.CIdentifierTypeModel.trim(), 'default', event, 1, c);
      } else {
        this.selectedCIddentifier2(this.CIdentifierTypeModel.trim(), "", event, 1, c);
      }
    } else {
      this.CIdentifierValue = [];
    }
    this.idenTypeChange = false;
  }

  selectedCIddentifier2(_event: any, _from = "", valueFromusr: any, page = 1, byClick = "No") {
    console.info('srch value>>', this.CIdentifierTypeModel, page, byClick);
    if (byClick == "ckedd") {
      this.loadPayingDatabase(page, [], 'continue')
    } else {
      if (byClick == "cked") {
        this.loading = true;
        this.data = "";
        this.data = [];
        this.KeyIdentifierValue = "";
        this.KeyIdentifierValue = [];
        this.KeyAllianceIvalueCmpName = "";
        this.KeyAllianceIvalueCmpName = [];
        this.alcorCodesOnCpyIds = [];
      }
      if (this.srchSelector == "CmpName") {
        this.CmpValuekeyup(this.CmpNameeModel.trim(), page, byClick);
      } else if (this.srchSelector == 'filter') {
        this.showCpyWithoutAssignments(page);
      } else if (this.srchSelector == 'no-filter') {
        this.searchCompanyWithoutFilter(page);
      } else if (this.srchSelector == 'status') {
        this.searchCompanyStatus(page);
      } else if (this.srchSelector == 'orbisStatus') {
        this.orbisLoading(page);
      }
      else if (this.srchSelector == 'workflowStatus') {
        this.searchCompanyWorkflowStatus(page);
      }
      else if (this.srchSelector == 'activity') {
        this.searchActivityType(page);
      } else {
        if (valueFromusr == "") {
          valueFromusr = this.IdentifierValueModel.trim();
        }
        this.CIdentifierValue = [];
        if (this.CIdentifierTypeModel == 'GTOP/MDM') {
          this.CidenTypeselectedValue = 'MDM';
        } else {
          this.CidenTypeselectedValue = this.CIdentifierTypeModel;
        }

        if (this.CidenTypeselectedValue == CompanyComponent.IDENTIFIER_TYPE) {
          this.autoload1 = true
          this.supplierService.getCompanies(
            `${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${valueFromusr.trim()}*&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`
          ).subscribe((data: any) => {
            this.CIdentifierValue = "";
            this.CIdentifierValue = [];
            this.pageinCid = "";
            this.pageinCid = [];
            this.pageInAlianId = "";
            this.CIdentifierValueCheck = "";
            this.CIdentifierValueCheck = [];
            this.autoload1 = false
            data['companies'].forEach(element => {
              this.CIdentifierValue.push(element.allianceIdentifier);
              this.KeyIdentifierValue[element.allianceIdentifier] = element;
              this.KeyAllianceIvalueCmpName[`${element.allianceIdentifier}___${element.legalName}`] = element;
              this.pageinCid.push(element.rowId);
            });
            if (data['companies'].length == 0) {
              this.loading = false;
              this.loadData = false;
            }
            this.pageAllinfos['totalItems'] = data['count'];
            this.pageAllinfos['currentPage'] = page;
            this.pageAllinfos['pageSize'] = data['pageCount'];
            if (byClick == "cked") {
              setTimeout(function () {
                this.getSearch();
              }.bind(this), SHORT_DELAY_MS);
            }
          });
        } else if (this.IdenKeywithId[this.CidenTypeselectedValue] != undefined) {
          let tempConst = '';
          this.autoload1 = true
          if (this.CidenTypeselectedValue.toLowerCase() == 'mdm' || this.CidenTypeselectedValue.toLowerCase() == 'gtop' || this.CidenTypeselectedValue.toLowerCase() == 'gtop/mdm') {
            tempConst = `in(${this.IdenKeywithId['GTOP']},${this.IdenKeywithId['MDM']})`;
          } else {
            tempConst = this.IdenKeywithId[this.CidenTypeselectedValue];
          }
          this.supplierService.getCompanyIdentifiers(
            `${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierTypeId=${tempConst}&value=*${valueFromusr.trim()}*&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`
          ).subscribe((data: any) => {
            this.pageinCid = "";
            this.pageinCid = [];
            this.pageInAlianId = "";
            this.CIdentifierValue = "";
            this.CIdentifierValue = [];
            this.CIdentifierValueCheck = "";
            this.CIdentifierValueCheck = [];
            this.alcorCodesOnCpyIds = [];
            this.autoload1 = false
            data['company-identifiers'].forEach(element5 => {
              this.CIdentifierValue.push(element5.value);
              this.CIdentifierValueCheck[`${element5.value}___${element5.companyAllianceIdentifier}`] = element5;
              this.pageinCid.push(element5.linkedCompanyId);
              this.pageInAlianId += `'${element5.companyAllianceIdentifier}',`;
            });
            if (data['company-identifiers'].length == 0) {
              this.loading = false;
              this.loadData = false;
            }
            this.pageAllinfos['totalItems'] = data['count'];
            this.pageAllinfos['currentPage'] = page;
            this.pageAllinfos['pageSize'] = data['pageCount'];
            if (this.pageInAlianId.slice(0, -1) != "") {
              this.AllcmpLeglName(this.pageInAlianId.slice(0, -1));
            }
            if (byClick == "cked") {
              setTimeout(function () {
                this.getSearch();
              }.bind(this), SHORT_DELAY_MS);
            }
          });
        } else if (this.CidenTypeselectedValue == 'Company Short Name') {
          this.autoload1 = true
          this.supplierService.getCompanyNames(
            `${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=SHORT NAME&value=*${valueFromusr.trim()}*&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`
          ).subscribe(data100 => {
            this.pageinCid = "";
            this.pageinCid = [];
            this.pageInAlianId = "";
            this.CIdentifierValue = "";
            this.alcorCodesOnCpyIds = [];
            this.CIdentifierValue = [];
            this.CIdentifierValueCheck = "";
            this.CIdentifierValueCheck = [];
            this.autoload1 = false
            data100['company-names'].forEach(element10 => {
              this.CIdentifierValue.push(element10.value);
              this.CIdentifierValueCheck[`${element10.value}___${element10.companyAllianceIdentifier}`] = element10;
              this.pageinCid.push(element10.companyId);
              this.pageInAlianId += `'${element10.companyAllianceIdentifier}',`;
            });
            if (data100['company-names'].length == 0) {
              this.loading = false;
              this.loadData = false;
            }
            this.pageAllinfos['totalItems'] = data100['count'];
            this.pageAllinfos['currentPage'] = page;
            this.pageAllinfos['pageSize'] = data100['pageCount'];
            if (this.pageInAlianId.slice(0, -1) != "") {
              this.AllcmpLeglName(this.pageInAlianId.slice(0, -1));
            }
            if (data100['company-names'].length == 0) {
              this.loading = false;
              this.loadData = false;
            }
            if (byClick == "cked") {
              setTimeout(function () {
                this.getSearch();
              }.bind(this), CompanyComponent.BATCH_REFRESH_DELAY_MS);
            }
          });
        } else if (this.CidenTypeselectedValue == 'BvD ID' || this.CidenTypeselectedValue == 'DUNS' || this.CidenTypeselectedValue == 'BPN' || this.CidenTypeselectedValue == 'Tax ID') {
          this.type = this.CidenTypeselectedValue == 'BvD ID' ? 'BVD ID' : this.CidenTypeselectedValue == 'DUNS' ? 'DUNS' : 'BPN-L';
          this.autoload1 = true
          if (this.CidenTypeselectedValue != 'Tax ID') {
            this.supplierService.getBusinessEntityIdentifiers(
              `${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=${this.type}&value=*${valueFromusr}*&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`
            ).subscribe(data00 => {
                this.pageinCid = "";
                this.pageinCid = [];
                this.pageInAlianId = "";
                this.CIdentifierValue = "";
                this.alcorCodesOnCpyIds = [];
                this.CIdentifierValue = [];
                this.CIdentifierValueCheck = "";
                this.CIdentifierValueCheck = [];
                this.autoload1 = false
                data00['business-entity-identifiers'].forEach(element10 => {
                  this.CIdentifierValue.push(element10.value);
                  this.pageInAlianId += `'${element10.businessEntityAllianceIdentifier}',`;
                });
                if (data00['business-entity-identifiers'].length == 0) {
                  this.loading = false;
                  this.loadData = false;
                }
                this.pageAllinfos['totalItems'] = data00['count'];
                this.pageAllinfos['currentPage'] = page;
                this.pageAllinfos['pageSize'] = data00['pageCount'];
                if (this.pageInAlianId.slice(0, -1) != "") {
                  this.allBusinessEntities(this.pageInAlianId.slice(0, -1));
                }
                if (byClick == "cked") {
                  setTimeout(function () {
                    this.getSearch();
                  }.bind(this), CompanyComponent.BATCH_REFRESH_DELAY_MS);
                }
              });
          } else {
            this.supplierService.getBusinessEntityIdentifiers(
              `${this.Config.ApiSupplierUrl}business-entity-identifiers?value=*${valueFromusr}*&businessEntityIdentifierType=TAXATION&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`
            ).subscribe(data00 => {
                this.pageinCid = "";
                this.pageinCid = [];
                this.pageInAlianId = "";
                this.CIdentifierValue = "";
                this.alcorCodesOnCpyIds = [];
                this.CIdentifierValue = [];
                this.CIdentifierValueCheck = "";
                this.CIdentifierValueCheck = [];
                this.autoload1 = false
                data00['business-entity-identifiers'].forEach(element10 => {
                  this.CIdentifierValue.push(element10.value);
                  this.pageInAlianId += `'${element10.businessEntityAllianceIdentifier}',`;
                });
                if (data00['business-entity-identifiers'].length == 0) {
                  this.loading = false;
                  this.loadData = false;
                }
                this.pageAllinfos['totalItems'] = data00['count'];
                this.pageAllinfos['currentPage'] = page;
                this.pageAllinfos['pageSize'] = data00['pageCount'];
                if (this.pageInAlianId.slice(0, -1) != "") {
                  this.allBusinessEntities(this.pageInAlianId.slice(0, -1));
                }
                if (byClick == "cked") {
                  setTimeout(function () {
                    this.getSearch();
                  }.bind(this), CompanyComponent.BATCH_REFRESH_DELAY_MS);
                }
              });
          }
        }
      }

    }
  }

  companyIdnetifiersMDI(inquery) {
    this.supplierService.getCompanyIdentifiers(
      `${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=MAIN TAX ID&linkedCompanyId=in(${inquery})`
    ).subscribe((data: any) => {
      data['company-identifiers'].forEach(element => {
        if (element.companyIdentifierKeyName == "MAIN TAX ID") {
          this.CmpIdentifierCIDBased[element.linkedCompanyId] = element;
        }
      });
    });
  }

  AllGrpAssignments(inquery, page = 1, subscribeData = []) {
    if (inquery.length > 0) {
      this.supplierService.getGroupAssignments(
        `${this.Config.ApiSupplierUrl}group-assignments?apoStatus=ACTIVE&companyId=in(${inquery})&_page=${page}`
      ).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
        if (data['group-assignments'].length > 0) {
          data['group-assignments'].forEach(element => {
            if (element.apoStatus == "ACTIVE") {
              this.CmpIdgroupAssign[element.companyId] = element.groupName;
              this.CmpRouting[element.companyId] = element.groupId
            }
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.AllGrpAssignments(inquery, page + 1, subscribeData);
          } else if (data['maxPage'] == page) {
            this.loadData = true;
            this.loading = false;
          }
        }
      });
    } else {
      this.loadData = false;
      this.loading = false;
    }
  }

  AllcmpLeglName(inIDs, page = 1, subscribeData = []) {
    this.cmpIDwithDetails = [];
    this.supplierService.getCompanies(
      `${this.Config.ApiSupplierUrl}companies?allianceIdentifier=in(${inIDs.toString()})&_page=${page}`
    ).subscribe((data: any) => {
      if (data['companies'].length > 0) {
        data['companies'].forEach(element7 => {
          let tmpCD = [];
          tmpCD['legalName'] = element7.legalName;
          tmpCD['companyStatusCode'] = element7.companyStatusCode;
          tmpCD['workflowStatus'] = element7.workflowStatus;
          this.cmpIDwithDetails[element7.rowId] = tmpCD;
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.AllcmpLeglName(inIDs, page + 1, subscribeData);
        } else {
          this.patchDataWithCompanyDetails();
        }
      }
    });
  }

  private patchDataWithCompanyDetails() {
    if (!this.data || !this.data.length) { return; }
    this.data.forEach((row: any) => {
      const details = this.cmpIDwithDetails[row['rowId']];
      if (!details) { return; }
      if (!row['legalName']) { row['legalName'] = details['legalName'] || ''; }
      if (!row['companyStatusCode']) { row['companyStatusCode'] = details['companyStatusCode'] || ''; }
      if (!row['workflowStatus']) { row['workflowStatus'] = details['workflowStatus'] || ''; }
    });
  }

  allBusinessEntities(allIds, page = 1, subscribeData = [], tempF = "") {
    this.cmpIDwithDetails = [];
    this.supplierService.getBusinessEntities(
      `${this.Config.ApiSupplierUrl}business-entities?identifier=in(${allIds.toString()})&_page=${page}`
    ).subscribe(data01 => {
      if (data01['business-entities'].length > 0) {
        data01['business-entities'].forEach(element8 => {
          this.CIdentifierValueCheck[element8.companyId] = element8;
          tempF += `'${element8.companyAllianceIdentifier}',`;
          this.pageinCid.push(element8.companyId);
        });
        if (data01['maxPage'] > 1 && data01['maxPage'] != page) {
          this.allBusinessEntities(allIds, page + 1, subscribeData, tempF);
        } else if (data01['maxPage'] == page) {
          if (tempF.slice(0, -1) != "") {
            this.AllcmpLeglName(tempF.slice(0, -1));
          }
          this.pageAllinfos['totalItems'] = data01['count'];
          this.pageAllinfos['currentPage'] = page;
          this.pageAllinfos['pageSize'] = data01['pageCount'];
        }
      }
    });
  }

  getSearch() {
    this.loading = true;
    console.info(this.idenTypeChange, this.CIdentifierTypeModel);
    if (this.filterCpyModel != '' && this.IdentifierValueModel == "" && this.CmpNameeModel == '') {
      this.showCpyWithoutAssignments(1);
    }
    if (((this.IdentifierValueModel != undefined && this.IdentifierValueModel.trim() != "" && this.IdentifierValueModel.length >= this.minlength) || (this.CmpNameeModel != undefined && this.CmpNameeModel.trim() != "" && this.CmpNameeModel.length >= this.numberthree)) && this.idenTypeChange == false) {
      this.pager = this.pagerService.getPager(this.pageAllinfos['totalItems'], this.pageAllinfos['currentPage'], this.maxRecorePage);
      this.PageTotalLength = this.pageAllinfos['totalItems'];
      if (this.pageAllinfos['pageSize'] <= TEN) {
        this.pageHeight = this.pageAllinfos['pageSize'] * CompanyComponent.PAGE_HEIGHT_ROLE_ROW_FACTOR + CompanyComponent.PAGE_HEIGHT_BASE_OFFSET;
      } else {
        this.pageHeight = CompanyComponent.PAGE_HEIGHT_FALLBACK;
      }
      if (this.pageinCid.length > 0) {
        this.AllGrpAssignments(this.pageinCid);
        this.loadShortNameForCpy(this.pageinCid);
        this.getBusinessEntitiesIsHQ(this.pageinCid);
        this.getCpyAlcorCodes(this.pageinCid);
        if (this.CidenTypeselectedValue == 'BvD') {
        } else {
        }
      }
      this.data = "";
      this.data = [];
      if (this.CIdentifierTypeModel == CompanyComponent.IDENTIFIER_TYPE || this.srchSelector == "CmpName") {
        if (Object.entries(this.KeyAllianceIvalueCmpName).length > 0) {
          for (const [key4, value4] of Object.entries(this.KeyAllianceIvalueCmpName)) {
            let tempP4 = key4.split("___");
            if ((this.IdentifierValueModel != "" && this.IdentifierValueModel != undefined && tempP4[0] != "" && tempP4[0].toLowerCase().includes(this.IdentifierValueModel.trim().toLowerCase())) || (this.CmpNameeModel != "" && this.CmpNameeModel != undefined && tempP4[1] != "" && tempP4[1].toLowerCase().includes(this.CmpNameeModel.toLowerCase().trim()))) {
              this.data.push(this.KeyIdentifierValue[tempP4[0]]);
              this.loadData = true;
              this.loading = true;
            }
          }
          console.info(this.data)
        } else {
          this.loadData = false;
          this.loading = false;
        }
      } else {
        if (this.CidenTypeselectedValue == 'Company Short Name' && Object.entries(this.CIdentifierValueCheck).length > 0) {
          for (const [key, value] of Object.entries(this.CIdentifierValueCheck)) {
            let NewVal = [];
            NewVal['rowId'] = value['companyId'];
            NewVal['legalName'] = value['legalName'];
            NewVal['allianceIdentifier'] = value['companyAllianceIdentifier'];
            NewVal['legalName'] = this.cmpIDwithDetails[value['companyId']]['legalName'] == undefined ? '' : this.cmpIDwithDetails[value['companyId']]['legalName'];
            NewVal['companyStatusCode'] = this.cmpIDwithDetails[value['companyId']]['companyStatusCode'] == undefined ? '' : this.cmpIDwithDetails[value['companyId']]['companyStatusCode'];
            NewVal['workflowStatus'] = this.cmpIDwithDetails[value['companyId']]['workflowStatus'] == undefined ? '' : this.cmpIDwithDetails[value['companyId']]['workflowStatus'];
            this.data.push(NewVal);
          }
          this.loadData = true;
          this.loading = true;
        }
        else if ((this.CidenTypeselectedValue == 'BvD ID' || this.CidenTypeselectedValue == 'DUNS' || this.CidenTypeselectedValue == 'BPN' || this.CidenTypeselectedValue == 'Tax ID') && Object.entries(this.CIdentifierValueCheck).length > 0) {
          for (const [key, value] of Object.entries(this.CIdentifierValueCheck)) {
            let NewVal = [];
            NewVal['rowId'] = value['companyId'];
            NewVal['legalName'] = value['companyLegalName'];
            NewVal['allianceIdentifier'] = value['companyAllianceIdentifier'];
            if (this.cmpIDwithDetails[value['companyId']]) {
              NewVal['companyStatusCode'] = this.cmpIDwithDetails[value['companyId']]['companyStatusCode'];
              NewVal['workflowStatus'] = this.cmpIDwithDetails[value['companyId']]['workflowStatus'];
            }
            this.data.push(NewVal);
          }
          this.loadData = true;
          this.loading = true;
        }
        else if (Object.entries(this.CIdentifierValueCheck).length > 0) {
          console.info(this.cmpIDwithDetails);
          const exactSelection = this.selectedIdentiValue && this.selectedIdentiValue !== 'failed' ? this.selectedIdentiValue : null;
          for (const [key, value] of Object.entries(this.CIdentifierValueCheck)) {
            if (exactSelection && key.split('___')[0] !== exactSelection) { continue; }
            let NewVal = [];
            NewVal['rowId'] = value['linkedCompanyId'];
            NewVal['legalName'] = value['linkedCompanyId'];
            NewVal['allianceIdentifier'] = value['companyAllianceIdentifier'];
            NewVal['legalName'] = this.cmpIDwithDetails[value['linkedCompanyId']] ? this.cmpIDwithDetails[value['linkedCompanyId']]['legalName'] == undefined ? '' : this.cmpIDwithDetails[value['linkedCompanyId']]['legalName'] : '';
            NewVal['companyStatusCode'] = this.cmpIDwithDetails[value['linkedCompanyId']] ? this.cmpIDwithDetails[value['linkedCompanyId']]['companyStatusCode'] == undefined ? '' : this.cmpIDwithDetails[value['linkedCompanyId']]['companyStatusCode'] : '';
            NewVal['workflowStatus'] = this.cmpIDwithDetails[value['linkedCompanyId']] ? this.cmpIDwithDetails[value['linkedCompanyId']]['workflowStatus'] == undefined ? '' : this.cmpIDwithDetails[value['linkedCompanyId']]['workflowStatus'] : '';
            this.data.push(NewVal);
          }
          this.loadData = true;
          this.loading = true;
        } else {
          this.loadData = false;
          this.loading = false;
        }
      }
    } else if (this.idenTypeChange == true) {
      this.IdValueKeyup(this.IdentifierValueModel.trim());
    } else if ((this.IdentifierValueModel == undefined || this.IdentifierValueModel == '') && (this.CmpNameeModel == undefined || this.CmpNameeModel == '') && (this.selectedStatus == undefined || this.selectedStatus == '') && (this.selectedActivityType == undefined || this.selectedActivityType == '') && (this.selectedOrbisStatus == undefined || this.selectedOrbisStatus == '') && (this.selectedWorkflowStatus == undefined || this.selectedWorkflowStatus == '') && this.filterCpyModel == '') {
      this.srchSelector = 'no-filter';
      this.searchCompanyWithoutFilter();
    } else if (this.selectedStatus != '') {
      this.srchSelector = 'status';
      this.searchCompanyStatus();
    } else if (this.selectedOrbisStatus != '') {
      this.srchSelector = 'orbisStatus';
      this.searchCompanyOrbisStatus();
    } else if (this.selectedWorkflowStatus != '') {
      this.srchSelector = 'workflowStatus';
      this.searchCompanyWorkflowStatus();
    } else if (this.selectedActivityType != '') {
      this.srchSelector = 'activity';
      this.searchActivityType();
    }
  }

  onIdentivalueSelect(selected) {
    if (selected) {
      this.selectedIdentiValue = selected;
      this.IdentifierValueModel = selected;
      this.userQuestionUpdate.setValue(selected, { emitEvent: false });
      this.IdValueKeyup(selected.trim());
    } else {
      this.selectedIdentiValue = "failed";
    }
  }

  onCompNameSelect(selected) {

    if (selected) {
      this.selectedcmpName = selected
    } else {
      this.selectedcmpName = "failed";
    }
  }

  onItemKey(event) {
    if (event['keyCode'] == KEY_ENTER) {
      this.enterKey = false;
      if (this.pageAllinfos) {
        this.pageAllinfos['currentPage'] = 1;
      }
      this.getSearch();
    } else {
      this.enterKey = true
    }
  }

  clearFields(resetparam: any) {
    if (resetparam == "All") {
      this.IdentifierValueModel = '';
      this.CmpNameeModel = '';
      this.selectedActivityType = '';
      this.userQuestionUpdate.setValue('');
      this.userQuestionUpdate2.setValue('');
      this.activityTypeCtrl.setValue('');
      this.activityCtrl.setValue('');
      this.data = "";
      this.loadData = false;
      this.filterCpyModel = '';
      this.selectedStatus = '';
      this.selectedOrbisStatus = '';
      this.selectedWorkflowStatus = '';
    } else if (resetparam == 'IdentifierValueFLag') {
      this.IdentifierValueModel = '';
      this.selectedActivityType = '';
      this.userQuestionUpdate.setValue('');
      this.activityTypeCtrl.setValue('');
      this.activityCtrl.setValue('');
    } else if (resetparam == 'companyNameFLag') {
      this.userQuestionUpdate2.setValue('');
    }
  }

  updateCreateCompanyExistsName() {
    this.saveDatas = 'Save';
    this.companyNameModel = '';
    this.companyTaxIdentyModel = '';
    this.companyNameModelError = false;
    this.companyNameModelRegExError = false;
    this.disableCompCreateBtn = false;
  }

  resetCompanyNameFields() {
    this.companyNameModel = '';
    this.companyNameModelError = true;
    this.companyNameModelRegExError = false;
  }

  checkvalidateCosmpanyNameField() {
    if (this.companyNameModel == '') {
      this.companyNameModelError = true;
    } else {
      this.companyNameModelError = false;
    }
  }

  checkvalidateCompanyNameField(expression, model, modelerror, regexmodel) {
    if (/^\s/.test(expression)) {
      this[model] = expression.trimStart();
      return false;
    }
    this[model] = expression.replace(/(\r\n|\n|\r)/gm, "");
    if (expression.length > 0) {
      this[modelerror] = false;
      if (!expression.match(/^[a-zA-Z 0-9\.\,\/\-\(\)]*$/gm)) {
        this[regexmodel] = true;
      } else {
        this[regexmodel] = false;
      }
    } else {
      this[regexmodel] = false;
      this[modelerror] = true;
    }
  }

  resetTaxIdentiFields() {
    this.companyTaxIdentyModel = '';
  }

  saveCompanyDetails() {
    if (this.companyNameModel != '' && this.companyNameModel != undefined && this.companyNameModelRegExError == false) {
      this.saveDatas = "Save...";
      this.disableCompCreateBtn = true;
      this.companyNameModelError = false;
      let cmpNameTypeID = "";
      this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types`).subscribe((data18: any) => {
        console.info("company-name-types", data18);
        data18['company-name-types'].forEach(element => {
          if (element.name.toLowerCase() == "short name") {
            cmpNameTypeID = element.row_id;
          }
        });
      });

      this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status`).subscribe((data: any) => {
        data['company-status'].forEach(element => {
          if (element.code.toLowerCase() == "identified") {
            this.companyStatusRowid = element.row_id
          }
        });
        if (this.companyStatusRowid != '' && this.groupMdmSwitch) {
          const datas = { legalName: this.companyNameModel, companyStatusId: this.companyStatusRowid, companyStatusCode: 'Identified', startDate: this.commonService.getTodayDate() };
          this.supplierService.createCompany(`${this.Config.ApiSupplierUrl}companies?noMdm=1`, datas).subscribe((dataGroup: any) => {
            this.companyRowId = dataGroup['rowId'];
            this.mainTaxRowid = this.IdenKeywithId['EUROPEAN VAT NUMBER'];
            if (this.companyTaxIdentyModel != '' && this.companyTaxIdentyModel != undefined) {
              const datas = { linkedCompanyId: this.companyRowId, companyIdentifierTypeId: this.mainTaxRowid, value: this.companyTaxIdentyModel, startDate: this.commonService.getTodayDate() };
              this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas).subscribe((_dataGApprovals: any) => {
              });
            }
            let shortName = this.companyNameModel.split(' ').join('');
            if (shortName.length <= TEN) {
              shortName = shortName.padEnd(TEN);
            } else if (shortName.length > TEN) {
              shortName = shortName.slice(0, TEN);
            }
            const datas3 = { companyId: this.companyRowId, companyNameTypeId: cmpNameTypeID, "value": shortName, startDate: this.commonService.getTodayDate() }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas3).subscribe((_data: any) => {
              const closeBtn = window.document.getElementById("closeCompBtn");
              if (closeBtn) {
                closeBtn.click();
              } else {
                alert('not closed')
              }

              this.router.navigate(['/company-details', this.companyRowId]);
            });
            this.saveDatas = "Save";
            this.disableCompCreateBtn = false;
          });
        } else if (this.companyStatusRowid != '' && !this.groupMdmSwitch) {
          const datas = { legalName: this.companyNameModel, companyStatusId: this.companyStatusRowid, companyStatusCode: 'Identified', startDate: this.commonService.getTodayDate() };
          this.supplierService.createCompany(`${this.Config.ApiSupplierUrl}companies?noMdm=1`, datas).subscribe((dataGroup: any) => {
            this.companyRowId = dataGroup['rowId'];
            this.mainTaxRowid = this.IdenKeywithId['EUROPEAN VAT NUMBER'];
            if (this.companyTaxIdentyModel != '' && this.companyTaxIdentyModel != undefined) {
              const datas = { linkedCompanyId: this.companyRowId, companyIdentifierTypeId: this.mainTaxRowid, value: this.companyTaxIdentyModel, startDate: this.commonService.getTodayDate() };
              this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas).subscribe((_dataGApprovals: any) => {
              });
            }
            let shortName = this.companyNameModel.split(' ').join('');
            if (shortName.length <= TEN) {
              shortName = shortName.padEnd(TEN);
            } else if (shortName.length > TEN) {
              shortName = shortName.slice(0, TEN);
            }
            const datas3 = { companyId: this.companyRowId, companyNameTypeId: cmpNameTypeID, "value": shortName, startDate: this.commonService.getTodayDate() }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}company-names`, datas3).subscribe((_data: any) => {
              const closeBtn = window.document.getElementById("closeCompBtn");
              if (closeBtn) {
                closeBtn.click();
              } else {
                alert('not closed')
              }

              this.router.navigate(['/company-details', this.companyRowId]);
            });
            this.saveDatas = "Save";
            this.disableCompCreateBtn = false;
          });
        }
      });

    } else {
      if (this.companyNameModel == '') {
        this.companyNameModelError = true;
      } else if (this.companyNameModel != '') {
        this.companyNameModelError = false;
      }
    }
  }

  loadPayingDatabase(page = 1, _subscribeData = [], loop = 'start') {
    if (loop == 'start') {
      this.payingCpyData = [];
      this.allPayingCpyData = [];
      this.payingCpyLoading = true;
      // Fetch all pages to get complete dataset
      this.fetchAllPayingCompanyPages(1);
    } else {
      // Apply sorting and pagination on already loaded data
      this.applySortAndPagination(page);
    }
  }

  fetchAllPayingCompanyPages(page = 1) {
    const apiUrl = `${this.Config.ApiSupplierUrl}paying-company?_page=${page}`;
    
    this.supplierService.get(apiUrl).subscribe(data => {
      if (data['paying-company'] && data['paying-company'].length > 0) {
        data['paying-company'].forEach(e => {
          this.allPayingCpyData.push(e);
        });
        
        // Check if there are more pages
        const totalItems = data['count'];
        const pageSize = data['pageCount'] || TEN;
        const totalPages = Math.ceil(totalItems / pageSize);
        
        if (page < totalPages) {
          // Fetch next page
          this.fetchAllPayingCompanyPages(page + 1);
        } else {
          // All data loaded, now apply sorting and pagination
          this.pageAllinfos['totalItems'] = totalItems;
          this.PageTotalLength = totalItems;
          this.applySortAndPagination(1);
          this.payingCpyLoading = false;
        }
      } else {
        this.payingCpyLoading = false;
        this.applySortAndPagination(1);
      }
    }, _error => {
      this.payingCpyLoading = false;
    });
  }

  applySortAndPagination(page = 1) {
    // Sort all data if sort key is set
    let sortedData = [...this.allPayingCpyData];
    
    if (this.payingSortKey) {
      sortedData.sort((a, b) => {
        const aVal = a[this.payingSortKey];
        const bVal = b[this.payingSortKey];
        
        if (aVal === null || aVal === undefined) return 1;
        if (bVal === null || bVal === undefined) return -1;
        
        let comparison = 0;
        if (aVal < bVal) {
          comparison = -1;
        } else if (aVal > bVal) {
          comparison = 1;
        }
        
        return this.payingSortReverse ? comparison * -1 : comparison;
      });
    }
    
    // Paginate the sorted data
    const pageSize = TWENTY;
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    
    this.payingCpyData = sortedData.slice(startIndex, endIndex);
    this.pageAllinfos['currentPage'] = page;
    this.pageAllinfos['pageSize'] = this.payingCpyData.length;
    this.payPager = this.pagerService.getPager(this.allPayingCpyData.length, page, pageSize);
    
    if (this.payingCpyData.length <= TWENTY) {
      this.pageHeight = this.payingCpyData.length * CompanyComponent.PAGE_HEIGHT_NAME_ROW_FACTOR + CompanyComponent.PAGE_HEIGHT_BASE_OFFSET;
    } else {
      this.pageHeight = CompanyComponent.PAGE_HEIGHT_FALLBACK;
    }
  }

  sortPayingCompany(key) {
    // If clicking the same column, toggle direction; otherwise set new column with ascending order
    if (this.payingSortKey === key) {
      this.payingSortReverse = !this.payingSortReverse;
    } else {
      this.payingSortKey = key;
      this.payingSortReverse = false;
    }
    // Apply sorting to all data and reset to page 1
    this.applySortAndPagination(1);
  }

  archivePayingCpyId(_row_id) {

  }

  loadShortNameForCpy(rowsData, page = 1, subscribeData = []) {
    this.ShortNameData = [];
    if (rowsData.length > 0) {
      this.supplierService.getCompanyNames(
        `${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=SHORT NAME&companyId=in(${rowsData})&_page=${page}`
      ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
        if (data['company-names'].length > 0) {
          for (let i = 0; i < data['company-names'].length; i++) {
            this.ShortNameData[data['company-names'][i]['companyId']] = data['company-names'][i];
          }
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.loadShortNameForCpy(rowsData, page + 1, subscribeData);
          } else if (data['maxPage'] == page) {
            console.info('ShortNameData', this.ShortNameData)
          }
        }
        this.loadData = true;
        this.loading = false;
      });
    } else {
      this.loading = false;
      this.loadData = true;
    }
  }

  loadCompanyNameForCpy(rowsData, page = 1, subscribeData = []) {
    if (rowsData.length > 0) {
      this.supplierService.getCompanies(
        `${this.Config.ApiSupplierUrl}companies?rowId=in(${rowsData})&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`
      ).subscribe(data => {
        if (data['companies'].length > 0) {
          for (let i = 0; i < data['companies'].length; i++) {
            let index = this.data.findIndex(x => x.rowId == data['companies'][i].rowId)
            if (index !== -1) {
              this.data[index].legalName = data['companies'][i].legalName;
              this.data[index].companyStatusCode = data['companies'][i].companyStatusCode;
              this.data[index].workflowStatus = data['companies'][i].workflowStatus;
            }
          }
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.loadCompanyNameForCpy(rowsData, page + 1, subscribeData);
          } else if (data['maxPage'] == page) {
          }
        }
        this.loadData = true;
        this.loading = false;
      });
    } else {
      this.loading = false;
      this.loadData = true;
    }
  }
  getBvdIDForCpy(cpyRowIds, selector, from = 'none', commonRows, sups, page = 1, subscribeData = []) {
    if (from == 'none') {
      let sups = '&isHQ=Y'
      if (selector == 'bvd') {
        sups = ''
      }
      this.BvdIDData = [];
      this.bvdRowId = [];
      let commonRows = [];
      if (cpyRowIds.length > 0) {
        this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=in(${cpyRowIds})${sups}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe(data0 => {
          if (data0['business-entities'].length > 0) {
            data0['business-entities'].forEach(e => {
              subscribeData.push(e);
            });
            if (data0['maxPage'] > 1 && data0['maxPage'] != page) {
              this.getBvdIDForCpy(cpyRowIds, selector, from, commonRows, sups, page + 1, subscribeData);
            } else if (data0['maxPage'] == page) {
              for (let j = 0; j < subscribeData.length; j++) {
                commonRows.push(subscribeData[j]['row_id']);
                this.bvdRowId[subscribeData[j]['row_id']] = subscribeData[j]['companyId'];
              }
              this.getBusinessIdenBvdId(commonRows, sups);
              console.info('bvdRowId', this.bvdRowId)
            }
          } else {
            this.getBusinessIdenBvdId(commonRows, sups);
          }
        });
      } else {
        this.PageTotalLength = this.pageAllinfos['totalItems'];
      }
    } else if (from == 'called' && commonRows.length > 0) {
      this.getBusinessIdenBvdId(commonRows, sups);
    }
  }

  getBusinessIdenBvdId(rows, select, page = 1, subscribeData = []) {
    if (rows.length > 0) {
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${rows})&businessEntityIdentifierTypeName=BVD%20ID&_page=${page}`).subscribe(data1 => {
        if (data1['business-entity-identifiers'].length > 0) {
          for (let h = 0; h < data1['business-entity-identifiers'].length; h++) {
            this.BvdIDData[this.bvdRowId[data1['business-entity-identifiers'][h]['businessEntityId']]] = data1['business-entity-identifiers'][h];
          }
          if (data1['maxPage'] > 1 && data1['maxPage'] != page) {
            this.getBusinessIdenBvdId(rows, select, page + 1, subscribeData);
          } else if (data1['maxPage'] == page) {
            console.info('BvdIDData', this.BvdIDData)
            this.loading = false;
            this.loadData = true;
            this.PageTotalLength = this.pageAllinfos['totalItems'];
          }
        } else {
          this.loading = false;
          this.loadData = true;
          this.PageTotalLength = this.pageAllinfos['totalItems'];
        }
      });
    } else {
      this.PageTotalLength = this.pageAllinfos['totalItems'];
      this.loading = false;
    }
  }

  showCpyWithoutAssignments(page = 1) {
    let srchParam = '';
    if (this.filterCpyModel == 'withoutCpy') {
      srchParam = 'company-without-assignment';
    } else if (this.filterCpyModel == 'withoutBvdId') {
      srchParam = 'company-without-bvd';
    }

    if (srchParam != '') {
      this.loadData = false;
      this.loading = true;
      let allianceIds = [];
      let allrowIds = [];
      this.data = [];
      this.supplierService.get(`${this.Config.ApiSupplierUrl}${srchParam}?_page=${page}${this.commonService.pageString}${this.maxRecorePage}`).subscribe(data11 => {
        if (data11['pageCount'] != 0) {
          for (let i = 0; i < data11['pageCount']; i++) {
            if (data11[srchParam][i]['company-identifier'] != '' && data11[srchParam][i]['company-identifier'] != undefined) {
              allianceIds.push(`'${data11[srchParam][i]['company-identifier']}'`);
            }
          }
          if (allianceIds.length > 0) {
            this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=in(${allianceIds})`).subscribe(data12 => {
              if (data12['companies'].length > 0) {
                this.data = [];
                for (let j = 0; j < data12['companies'].length; j++) {
                  this.data.push(data12['companies'][j]);
                  if (data12['companies'][j]['rowId'] != '' && data12['companies'][j]['rowId'] != undefined) {
                    allrowIds.push(data12['companies'][j]['rowId']);
                  }
                }
                if (srchParam != 'company-without-assignment') {
                  this.AllGrpAssignments(allrowIds);
                }
                if (srchParam != 'company-without-bvd') {
                }
                this.getBusinessEntitiesIsHQ(allrowIds);
                this.loadShortNameForCpy(allrowIds);
                this.getCpyAlcorCodes(allrowIds);
              } else {
                this.loadData = false;
              }
            });
          } else {
            this.loading = false;
          }
          this.pageAllinfos['totalItems'] = data11['count'];
          this.pageAllinfos['currentPage'] = page;
          this.pageAllinfos['pageSize'] = data11['pageCount'];
          this.pager = this.pagerService.getPager(this.pageAllinfos['totalItems'], this.pageAllinfos['currentPage'], this.maxRecorePage);
          this.PageTotalLength = this.pageAllinfos['totalItems'];
          if (data11['pageCount'] <= TEN) {
            this.pageHeight = data11['pageCount'] * CompanyComponent.PAGE_HEIGHT_NAME_ROW_FACTOR + CompanyComponent.PAGE_HEIGHT_BASE_OFFSET;
          } else {
            this.pageHeight = CompanyComponent.PAGE_HEIGHT_FALLBACK;
          }
        } else {
          this.loadData = false;
        }
      });
    }
  }

  hideEnv() {
    let c = this.commonService.getEnvSpecific();
    if (c == 'ope') {
      this.prodHide = true;
    } else { this.prodHide = false };
  }

  getBusinessEntitiesIsHQ(rowIds, page = 1, subscribeData = []) {
    this.cityAndCountryData = [];
    this.cpyRowIdsForAssn = [];
    if (rowIds.length > 0) {
      let businessRowIds = [];
      let commonRows = [];
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=in(${rowIds})&isHQ=Y&_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe(data => {
        if (data['business-entities'].length > 0) {
          data['business-entities'].forEach(element => {
            subscribeData.push(element);
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getBusinessEntitiesIsHQ(rowIds, page + 1, subscribeData);
          } else if (data['maxPage'] == page) {
            subscribeData.forEach(element => {
              commonRows.push(element['row_id']);
              this.bvdRowId[element['row_id']] = element['companyId'];
              businessRowIds.push(element.row_id);
            });
            this.getBvdIDForCpy(rowIds, '', 'called', commonRows, '&isHQ=Y');
            this.getSiteAssignmentsIsHQ(businessRowIds);
          }
        }
      });
    }
  }

  getSiteAssignmentsIsHQ(rowIds, page = 1, subscribeData = []) {
    if (rowIds.length > 0) {
      this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=in(${rowIds})&_page=${page}`).subscribe(data => {
        if (data['site-assignments'].length > 0) {
          data['site-assignments'].forEach(element => {
            subscribeData.push(element);
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getSiteAssignmentsIsHQ(rowIds, page + 1, subscribeData);
          } else if (data['maxPage'] == page) {
            let tempSiteRowIDs = [];
            subscribeData.forEach(element => {
              let s = element.site.href.split('/');
              this.cpyRowIdsForAssn[s[1]] = element.businessEntityCompanyId;
              tempSiteRowIDs.push(s[1]);
            });
            this.getSitesData(tempSiteRowIDs);
          }
        }
      });
    }
  }

  getSitesData(rowIds, page = 1, subscribeData = []) {
    if (rowIds.length > 0) {
      this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${rowIds})&_page=${page}`).subscribe(data => {
        if (data['sites'].length > 0) {
          data['sites'].forEach(element => {
            subscribeData.push(element);
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getSitesData(rowIds, page + 1, subscribeData);
          } else if (data['maxPage'] == page) {
            subscribeData.forEach(element => {
              this.cityAndCountryData[this.cpyRowIdsForAssn[element.rowId]] = element;
            });
          }
        }
      });
    }
  }

  cpyAlcorBatch(page, maxrecords = TWENTY) {
    this.pageBatchNo = page;
    this.cpyBatchBtn = 'Cancel';
    this.aliasTextDisp = '<img src="assets/images/loading.gif" alt="loading...">';
    if (this.pageBatchNo == 1) {
      this.cancelCpyAlcorProcessing = false;
      this.progressForCpyAlcor = '0';
    }
    if (this.cancelCpyAlcorProcessing == false) {
      this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&_page=${page}${this.commonService.pageString}${maxrecords}`).subscribe(data => {
        if (data['company-identifiers'].length > 0) {
          this.progressForCpyAlcor = ((this.pageBatchNo / data['maxPage']) * ONE_HUNDRED).toString();
          data['company-identifiers'].forEach(element => {
            if (element.value.length < SIX) {
              this.updateAlcorValue(element.row_id, element.value, data['page'], data['maxPage']);
            }
          });
          if (page < data['maxPage']) {
            this.cpyAlcorBatch(page + 1);
          }
          if (page == data['maxPage']) {
            this.cpyBatchBtn = 'OK';
            this.aliasTextDisp = 'Done Processing.'
          }
        }
      });
    }
  }

  updateAlcorValue(rowId, value, _page, _maxPage) {
    if (rowId != '' && rowId != undefined && this.cancelCpyAlcorProcessing == false) {
      let val = value.padStart(SIX, '0');
      console.info(val);
      const datas = { value: val }
      this.supplierService.updateCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers/${rowId}`, datas).subscribe(_data => {
      });
    }
  }

  getExcelFromHtmlAndDownload() {
    let todayDate = new Date();
    let element = document.getElementById('excelTableLog');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Set HQ batch');
    XLSX.writeFile(wb, `setHQBatch${todayDate.getTime()}.xlsx`);
  }

  stopSiteBatchAssnExe() {
    this.cancelCpyAlcorProcessing = true;
  }

  getCpyAlcorCodes(rowIds, page = 1) {
    if (rowIds.length > 0) {
      this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&linkedCompanyId=in(${rowIds})`).subscribe(data => {
        if (data['company-identifiers'].length > 0) {
          data['company-identifiers'].forEach(ele => {
            if (this.alcorCodesOnCpyIds[ele.linkedCompanyId] == undefined) {
              this.alcorCodesOnCpyIds[ele.linkedCompanyId] = [];
            }
            if (this.alcorCodesOnCpyIds[ele.linkedCompanyId].indexOf(ele.value) == -1) {
              if (ele.endDate == '') {
                this.alcorCodesOnCpyIds[ele.linkedCompanyId].push(ele.value);
              }
            }
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getCpyAlcorCodes(rowIds, page + 1);
          }
        }
      });
    }
  }

  searchCompanyWithoutFilter(page = 1) {
    this.data = '';
    this.data = [];
    this.pageinCid = '';
    this.pageinCid = [];
    this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?_page=${page}${this.commonService.pageString}${this.maxRecorePage}`).subscribe(data => {
      if (data['companies'].length > 0) {
        data['companies'].forEach(element => {
          let NewVal = [];
          NewVal['rowId'] = element['rowId'];
          NewVal['legalName'] = element['legalName'];
          NewVal['allianceIdentifier'] = element['allianceIdentifier'];
          NewVal['companyStatusCode'] = element['companyStatusCode'];
          NewVal['workflowStatus'] = element['workflowStatus'];
          this.data.push(NewVal);
          this.pageinCid.push(element['rowId']);
          this.loadData = true;
        });
      } else {
        this.loadData = false;
      }
      this.pageAllinfos['totalItems'] = data['count'];
      this.pageAllinfos['currentPage'] = page;
      this.pageAllinfos['pageSize'] = data['pageCount'];
      this.pager = this.pagerService.getPager(this.pageAllinfos['totalItems'], this.pageAllinfos['currentPage'], this.maxRecorePage);
      this.PageTotalLength = this.pageAllinfos['totalItems'];
      if (data['pageCount'] <= TEN) {
        this.pageHeight = data['pageCount'] * CompanyComponent.PAGE_HEIGHT_NAME_ROW_FACTOR + CompanyComponent.PAGE_HEIGHT_BASE_OFFSET;
      } else {
        this.pageHeight = CompanyComponent.PAGE_HEIGHT_FALLBACK;
      }
      if (this.pageinCid.length > 0) {
        this.AllGrpAssignments(this.pageinCid);
        this.loadShortNameForCpy(this.pageinCid);
        this.getBusinessEntitiesIsHQ(this.pageinCid);
        this.getCpyAlcorCodes(this.pageinCid);
      }
    });
  }

  openWorkflow() {
    let baseUrl1 = baseUrl
    if (baseUrl1 == opeUrl || baseUrl1 == opewafUrl || baseUrl1 == opeNewwafUrl) {
      window.open(`${share}HOME`);
    }
    else if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/` || baseUrl1 == intUrl) {
      window.open(`${dev}HOME`)
    }
    else {
      window.open(`${int}HOME`)
    }

  }
  searchActivityType(page = 1) {
    this.data = '';
    this.data = [];
    this.pageinCid = '';
    this.pageinCid = [];
    this.selectedActivityType = this.selectedActivityType == 'BOP' ? '#BOP' : this.selectedActivityType;
    if (this.selectedActivityType != undefined && this.selectedActivityType != '') {
      this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=SUPPLIER%20ACTIVITY&value=*${encodeURIComponent(this.selectedActivityType.trim())}&_page=${page}`).subscribe((data: any) => {

        if (data['company-names'].length > 0) {
          data['company-names'].forEach(element => {
            let NewVal = [];
            NewVal['rowId'] = element['companyId'];
            NewVal['legalName'] = '';
            NewVal['companyStatusCode'] = '';
            NewVal['workflowStatus'] = '';
            NewVal['activity'] = element['value'];
            NewVal['allianceIdentifier'] = element['companyAllianceIdentifier'];
            NewVal['companyId'] = element['companyId'];
            this.data.push(NewVal);
            this.pageinCid.push(element['companyId']);
            this.loadData = true;
          });
          this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?companyStatusId=${this.selectedStatus}&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`).subscribe(_data => {

          })
        } else {
          this.loadData = false;
        }
        this.pageAllinfos['totalItems'] = data['count'];
        this.pageAllinfos['currentPage'] = page;
        this.pageAllinfos['pageSize'] = data['pageCount'];
        this.pager = this.pagerService.getPager(this.pageAllinfos['totalItems'], this.pageAllinfos['currentPage'], this.maxRecorePage);
        this.PageTotalLength = this.pageAllinfos['totalItems'];
        if (data['pageCount'] <= TEN) {
          this.pageHeight = data['pageCount'] * CompanyComponent.PAGE_HEIGHT_ROLE_ROW_FACTOR + CompanyComponent.PAGE_HEIGHT_BASE_OFFSET;
        } else {
          this.pageHeight = CompanyComponent.PAGE_HEIGHT_FALLBACK;
        }
        if (this.pageinCid.length > 0) {
          console.info('data', this.data)
          this.loadCompanyNameForCpy(this.pageinCid);
          this.AllGrpAssignments(this.pageinCid);
          this.loadShortNameForCpy(this.pageinCid);
          this.getBusinessEntitiesIsHQ(this.pageinCid);
          this.getCpyAlcorCodes(this.pageinCid);
        }
      });
    }
  }

  searchCompanyStatus(page = 1) {
    this.data = '';
    this.data = [];
    this.pageinCid = '';
    this.pageinCid = [];
    if (this.selectedStatus != undefined && this.selectedStatus != '') {
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?companyStatusId=${this.selectedStatus}&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`).subscribe(data => {
        if (data['companies'].length > 0) {
          data['companies'].forEach(element => {
            let NewVal = [];
            NewVal['rowId'] = element['rowId'];
            NewVal['legalName'] = element['legalName'];
            NewVal['allianceIdentifier'] = element['allianceIdentifier'];
            NewVal['companyStatusCode'] = element['companyStatusCode'];
            NewVal['workflowStatus'] = element['workflowStatus'];
            this.data.push(NewVal);
            this.pageinCid.push(element['rowId']);
            this.loadData = true;
          });
        } else {
          this.loadData = false;
          this.loading = false;
        }
        this.pageAllinfos['totalItems'] = data['count'];
        this.pageAllinfos['currentPage'] = page;
        this.pageAllinfos['pageSize'] = data['pageCount'];
        this.pager = this.pagerService.getPager(this.pageAllinfos['totalItems'], this.pageAllinfos['currentPage'], this.maxRecorePage);
        this.PageTotalLength = this.pageAllinfos['totalItems'];
        if (data['pageCount'] <= TEN) {
          this.pageHeight = data['pageCount'] * CompanyComponent.PAGE_HEIGHT_ROLE_ROW_FACTOR + CompanyComponent.PAGE_HEIGHT_BASE_OFFSET;
        } else {
          this.pageHeight = CompanyComponent.PAGE_HEIGHT_FALLBACK;
        }
        if (this.pageinCid.length > 0) {
          console.info('data', this.data)

          this.AllGrpAssignments(this.pageinCid);
          this.loadShortNameForCpy(this.pageinCid);
          this.getBusinessEntitiesIsHQ(this.pageinCid);
          this.getCpyAlcorCodes(this.pageinCid);
        }
      });
    }
  }

  searchCompanyOrbisStatus(page = 1, rowIds = []) {
    if (page === 1) {
      this.data = '';
      this.data = [];
      this.pageinCid = '';
      this.pageinCid = [];
      this.allOrbisData = [];
      this.OrbisIdentifiers = [];
    }
    let count = 0;
    let search = ''
    if (this.selectedOrbisStatus != undefined && this.selectedOrbisStatus != '') {
      if (this.selectedOrbisStatus == 'Active') {
        search = 'active';
      } else if (this.selectedOrbisStatus == 'Active+') {
        search = `*${('Active ').replace(' ', '%20')}*`;
      } else {
        search = `*${this.selectedOrbisStatus.replace(' ', '%20')}*`;
      }
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=ORBIS-STATUS&value=${search}&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`).subscribe(data => {
        if (data['business-entity-identifiers'].length > 0) {
          data['business-entity-identifiers'].forEach(element => {
            count++;
            if (element['endDate'] == '') {
              this.allOrbisData.push(element)
              this.OrbisIdentifiers.push(`'${element['businessEntityAllianceIdentifier']}'`);
            }
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.searchCompanyOrbisStatus(page + 1, rowIds);
          } else if (page == data['maxPage']) {
            this.orbisLoading(1);
            if (this.data['pageCount'] <= TEN) {
              this.pageHeight = this.data['pageCount'] * CompanyComponent.PAGE_HEIGHT_ROLE_ROW_FACTOR + CompanyComponent.PAGE_HEIGHT_BASE_OFFSET;
            } else {
              this.pageHeight = CompanyComponent.PAGE_HEIGHT_FALLBACK;
            }
          }
        } else {
          this.loadData = false;
          this.loading = false;
        }
      });
    }
  }

  orbisLoading(page) {
    if (this.allOrbisData.length > 0) {
      this.data = [];
      this.pageinCid = [];
      let count = 0;
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?identifier=in(${this.OrbisIdentifiers})&_page=${page}`).subscribe(data => {
        if (data['business-entities'].length > 0) {
          data['business-entities'].forEach(data1 => {
            this.supplierService.getCompanyById(`${this.Config.ApiSupplierUrl}companies/${data1['companyId']}`).subscribe(element => {
              count++
              let NewVal = [];
              NewVal['rowId'] = element['rowId'];
              NewVal['legalName'] = element['legalName'];
              NewVal['allianceIdentifier'] = element['allianceIdentifier'];
              NewVal['companyStatusCode'] = element['companyStatusCode'];
              NewVal['workflowStatus'] = element['workflowStatus'];
              this.data.push(NewVal);
              this.pageinCid.push(element['rowId']);
              this.loadData = true;
              if (count == data['business-entities'].length) {
                this.pageAllinfos['totalItems'] = data['count'];
                this.pageAllinfos['currentPage'] = page;
                this.pageAllinfos['pageSize'] = data['pageCount'];
                this.pager = this.pagerService.getPager(this.pageAllinfos['totalItems'], this.pageAllinfos['currentPage'], this.maxRecorePage);
                this.PageTotalLength = this.pageAllinfos['totalItems'];
                if (data['pageCount'] <= TEN) {
                  this.pageHeight = data['pageCount'] * CompanyComponent.PAGE_HEIGHT_ROLE_ROW_FACTOR + CompanyComponent.PAGE_HEIGHT_BASE_OFFSET;
                } else {
                  this.pageHeight = CompanyComponent.PAGE_HEIGHT_FALLBACK;
                }
                if (this.pageinCid.length > 0) {
                  console.info('data', this.data)
                  this.loadData = true;
                  this.AllGrpAssignments(this.pageinCid);
                  this.loadShortNameForCpy(this.pageinCid);
                  this.getBusinessEntitiesIsHQ(this.pageinCid);
                  this.getCpyAlcorCodes(this.pageinCid);
                }
              }
            })
          });
        }
      })
      this.loadData = true;
    } else {
      this.loadData = false;
      this.loading = false;
    }
  }

  searchCompanyWorkflowStatus(page = 1) {
    this.data = '';
    this.data = [];
    this.pageinCid = '';
    this.pageinCid = [];
    if (this.selectedWorkflowStatus != undefined && this.selectedWorkflowStatus != '') {
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?workflowStatus=${this.selectedWorkflowStatus}&_page=${page}${this.commonService.pageString}${this.maxRecorePage}`).subscribe(data => {
        if (data['companies'].length > 0) {
          data['companies'].forEach(element => {
            let NewVal = [];
            NewVal['rowId'] = element['rowId'];
            NewVal['legalName'] = element['legalName'];
            NewVal['allianceIdentifier'] = element['allianceIdentifier'];
            NewVal['companyStatusCode'] = element['companyStatusCode'];
            NewVal['workflowStatus'] = element['workflowStatus'];
            this.data.push(NewVal);
            this.pageinCid.push(element['rowId']);
            this.loadData = true;
          });
        } else {
          this.loadData = false;
          this.loading = false;
        }
        this.pageAllinfos['totalItems'] = data['count'];
        this.pageAllinfos['currentPage'] = page;
        this.pageAllinfos['pageSize'] = data['pageCount'];
        this.pager = this.pagerService.getPager(this.pageAllinfos['totalItems'], this.pageAllinfos['currentPage'], this.maxRecorePage);
        this.PageTotalLength = this.pageAllinfos['totalItems'];
        if (data['pageCount'] <= TEN) {
          this.pageHeight = data['pageCount'] * CompanyComponent.PAGE_HEIGHT_ROLE_ROW_FACTOR + CompanyComponent.PAGE_HEIGHT_BASE_OFFSET;
        } else {
          this.pageHeight = CompanyComponent.PAGE_HEIGHT_FALLBACK;
        }
        if (this.pageinCid.length > 0) {
          console.info('data', this.data)

          this.AllGrpAssignments(this.pageinCid);
          this.loadShortNameForCpy(this.pageinCid);
          this.getBusinessEntitiesIsHQ(this.pageinCid);
          this.getCpyAlcorCodes(this.pageinCid);
        }
      });
    }
  }

  toggleMdmCode(_event) {
    this.groupMdmSwitch = !this.groupMdmSwitch
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
}